export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4688.be06ee9f.jpg";